var _defs, _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxUnchecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "checkbox-unchecked_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 1161.11 1161.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".checkbox-unchecked_svg__cls-1{fill:#35a4dd}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M580.56 30C277 30 30 277 30 580.56s247 550.55 550.56 550.55 550.55-247 550.55-550.55S884.13 30 580.56 30z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 580.56,
    cy: 777.78,
    r: 32.6,
    transform: "rotate(-22.5 580.546 777.775)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M580.56 306.63c-81.26 0-147.37 66.11-147.37 147.37a33.09 33.09 0 0066.18 0 81.19 81.19 0 1181.19 81.18 33.13 33.13 0 00-33.09 33.09v95.23a33.09 33.09 0 0066.18 0v-65.83l3.75-1a148.42 148.42 0 0079.07-51.8A146.66 146.66 0 00727.92 454c0-81.26-66.11-147.37-147.36-147.37z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxUnchecked);
export default ForwardRef;